<template>
  <div class="slide" @mouseover="stop()" @mouseout="move()">
    <div class="slideshow">
      <transition-group tag="ul" name="image">
        <li v-for="(item, index) in imgArray" v-show="index===mark" :key="item.id">
          <img :src='item.url' class="img">
        </li>
      </transition-group>
    </div>
    <div class="bar">
      <span class="barItem" v-for="(item, index) in imgArray" :class="{ 'active':index===mark }"
            @click="change(index)" :key="index"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timer: null, //定时器
      mark: 0, //比对图片索引的变量
      imgArray: [
        {url: require('@/assets/banner02.png'), id: 1},
        {url: require('@/assets/banner01.png'), id: 2},
        {url: require('@/assets/banner03.png'), id: 3},
      ]
    }
  },
  methods: {
    autoPlay() {
      this.mark++;
      if (this.mark === this.imgArray.length) {
        this.mark = 0
      }
    },
    play() {
      this.timer = setInterval(this.autoPlay, 3000)
    },
    change(i) {
      this.mark = i
    },
    stop() {
      clearInterval(this.timer)
    },
    move() {
      this.timer = setInterval(this.autoPlay, 3000)
    }
  },
  mounted() {
    this.play()
  },
  beforeMount() {
    clearInterval(this.timer)
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

.slide {
  width: 100%;
  height: 850px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.slideshow {
  width: 100%;
  height: 850px;
}

li {
  position: absolute;
}

.img {
  width: 100%;
  height: 850px;
}

.bar {
  position: absolute;
  width: 100%;
  bottom: 33px;
  margin: 0 auto;
  z-index: 10;
  text-align: center;
}

.barItem {
  display: inline-block;
  width: 18px !important;
  height: 18px;
  border: 1px solid #FFFFFF;
  border-radius: 50%;
  margin: 0 23px;
  cursor: pointer;
}

.active {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: #FFFFFF;
  border: 1px solid #FFFFFF;
  border-radius: 50%;
}

.image-enter-active {
  opacity: 1;
  transition: all 2s ease;
}

.image-enter-leave {
  opacity: .2;
  transition: all 2s ease;
}

.image-enter {
  opacity: 0;
}

.image-leave {
  opacity: 1;
}

li {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/components/swiperOne.vue